import React from 'react';
import DataTable from 'react-data-table-component';
import {useTranslate} from "@tolgee/react";

interface FacebookPagesTableProps {
    facebookPages: any[]; // Replace any with the actual type of a Facebook page
    facebookPagesConnectedCount: number;
    facebookPagesNotConnectedCount: number;
    columns: any[]; // Replace any with the actual type of a column
}

const FacebookPagesTable: React.FC<FacebookPagesTableProps> = ({
                                                                   facebookPages,
                                                                   facebookPagesConnectedCount,
                                                                   facebookPagesNotConnectedCount,
                                                                   columns
                                                               }) => {
    const {t} = useTranslate();

    return (
        <div className={'py-5'}>
            <div className={'d-flex flex-row'}>
                {facebookPagesConnectedCount != null &&
                    <div className={'h5 me-2'}>{t('verifyFacebookAccessToken.Connected')}: <span
                        className={"text-success"}>{facebookPagesConnectedCount}</span></div>}
                {facebookPagesNotConnectedCount != null && facebookPagesNotConnectedCount > 0 &&
                    <div className={'h5 me-2'}>{t('verifyFacebookAccessToken.notConnected')}: <span
                        className={"text-danger"}>{facebookPagesNotConnectedCount}</span></div>}
            </div>

            <div>
                <DataTable
                    columns={columns}
                    data={facebookPages}
                    pagination
                    paginationComponentOptions={{
                        rangeSeparatorText: t('verifyFacebookAccessToken.table.of'),
                        rowsPerPageText: t('verifyFacebookAccessToken.table.entries_per_page')
                    }}
                />
            </div>
        </div>
    );
};

export default FacebookPagesTable;
